export function setOptions (railwayData) {
  var colors = ['#FF0909', '#72FB03', '#ff6d00']
  var options = {
    color: colors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      formatter: function (params) {
        var relVal = params[0].name
        const unitArray = { 温度: '℃', 雨量: 'mm', 风速: 'm/s' }
        console.log(params[0].name)
        for (let i = 0, l = params.length; i < l; i++) {
          relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value + ' ' + unitArray[params[i].seriesName]
        }
        return relVal
      }
    },
    grid: {
      right: '20%',
      bottom: '15%'
    },
    toolbox: {
      feature: {
        dataView: { show: true, readOnly: false },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: ['温度', '雨量', '风速']
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      data: railwayData.xText
    }],
    yAxis: [{
      type: 'value',
      name: '℃',
      min: 0,
      axisLine: {
        show: true,
        lineStyle: {
          color: colors[0]
        }
      },
      axisLabel: {
        formatter: '{value}'
      }
    }, {
      type: 'value',
      name: 'm/s',
      min: 0,
      position: 'right',
      axisLine: {
        show: true,
        lineStyle: {
          color: colors[2]
        }
      },
      axisLabel: {
        formatter: '{value}'
      }
    }, {
      type: 'value',
      name: '(mm)',
      min: 0,
      position: 'right',
      offset: 50,
      axisLine: {
        show: true,
        lineStyle: {
          color: colors[1]
        }
      },
      axisLabel: {
        formatter: '{value}'
      }
    }],
    series: [{
      name: '温度',
      type: 'line',
      data: railwayData.tempGroup
    }, {
      name: '雨量',
      type: 'bar',
      yAxisIndex: 2,
      data: railwayData.rainGroup
    }, {
      name: '风速',
      type: 'line',
      yAxisIndex: 1,
      data: railwayData.windGroup
    }]
  }
  return options
}
